module.exports = __webpack_public_path__ + "static/media/verzenden-logo.8e335f77.svg";